import { QueryClient } from '@tanstack/react-query';

import { useNonBenefitMedicinesForSeoQuery } from '@/hooks/nonBenefit/nonBenefit.gql.impl';
import { NonBenefitMedicine, NonBenefitMedicines } from '@/models/nonBenefit';
import { NonBenefitMedicinesForSeoQuery } from '@/types/bff/gql-schema';

const parseNonBenefitMedicinesForSeo = (data: NonBenefitMedicinesForSeoQuery) => {
  const medicines = data.nonBenefitMedicinesForSeo.map((nonBenefitMedicine) => {
    return new NonBenefitMedicine({
      id: nonBenefitMedicine.id,
      medicineName: nonBenefitMedicine.medicineName,
      medicineDescription: nonBenefitMedicine.medicineDescription ?? '',
      units: nonBenefitMedicine.units.map((unit) => {
        return {
          id: unit.id,
          unit: unit.unit,
          unitType: unit.unitType,
          unitTypeDisplayName: unit.unitTypeDisplayName,
        };
      }),
      treatment: {
        id: nonBenefitMedicine.treatment.id,
        name: nonBenefitMedicine.treatment.name,
        isBenefit: nonBenefitMedicine.treatment.isBenefit,
        categoryId: nonBenefitMedicine.treatment.categoryId,
      },
    });
  });
  return new NonBenefitMedicines(medicines);
};

const useNonBenefitMedicinesForSeo = () => {
  const { data: nonBenefitMedicines = new NonBenefitMedicines([]), isLoading } = useNonBenefitMedicinesForSeoQuery(
    {},
    {
      select: parseNonBenefitMedicinesForSeo,
      refetchOnMount: false,
    }
  );

  return {
    isLoading,
    nonBenefitMedicines,
  };
};

const fetchQuery = async (queryClient: QueryClient) => {
  const response = await queryClient.fetchQuery(
    useNonBenefitMedicinesForSeoQuery.getKey({}),
    useNonBenefitMedicinesForSeoQuery.fetcher({})
  );

  return parseNonBenefitMedicinesForSeo(response);
};

export default useNonBenefitMedicinesForSeo;

useNonBenefitMedicinesForSeo.fetchQuery = fetchQuery;
